const COMMUNICATION_BANNER_BASE_KEY = 'communicationBanner';

export const communicationBannerQueryKeys = {
  detail: (storeId: string | number) =>
    [COMMUNICATION_BANNER_BASE_KEY, String(storeId)] as const,
};

export const communicationBannerUrls = {
  detail: (storeId: string | number) =>
    `/v1/stores/${storeId}/banner_message_settings`,
};
